import {
  getViolationsByMemberId,
  updateMemberViolation,
} from "../../../../Redux/Violation/ViolationActions";
import validator, { ValidationField } from "../../../../Util/validator";
import { AppDispatch, RootState } from "../../../../Redux/store";
import imageUrlHelper from "../../../../Util/imageUrlHelper";
import imageToBase64 from "../../../../Util/imageToBase64";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import styles from "./EditViolation.module.scss";
import { CiImageOn } from "react-icons/ci";
import { IoClose } from "react-icons/io5";

interface ViolationData {
  memberViolationId: number;
  memberId: number;
  description: string;
  score: number;
  image: string | null;
}

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  violationData: ViolationData | null;
  updateSuccessHandler?: () => void;
}

function EditViolation(props: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const { setIsOpen, violationData, updateSuccessHandler } = props;
  const { updateMemberViolationLoading } = useSelector(
    (state: RootState) => state.violations,
  );
  const imageRef = useRef<HTMLInputElement>(null);
  const [description, setDescription] = useState("");
  const [score, setScore] = useState("");
  const [image, setImage] = useState<File | string | null>(null);
  const [errors, setErrors] = useState({
    description: "",
    score: "",
  });

  useEffect(() => {
    if (violationData) {
      setDescription(violationData.description || "");
      setScore(
        violationData.score !== undefined && violationData.score !== null
          ? String(violationData.score)
          : "",
      );
      setImage(violationData.image || null);
    }
  }, [violationData]);

  const editViolationHandler = async () => {
    const fieldsArray = [
      {
        key: "description",
        value: description,
        type: "text",
      },
      {
        key: "score",
        value: score,
        type: "numberOnly",
      },
    ];

    const { errors: fieldsErrors, isValid } = validator(
      fieldsArray as ValidationField[],
    );

    setErrors({
      ...errors,
      ...fieldsErrors,
    });

    if (
      !isValid ||
      updateMemberViolationLoading ||
      !violationData?.memberViolationId
    ) {
      return;
    }

    const successHandler = () => {
      setIsOpen(false);
      if (updateSuccessHandler) {
        updateSuccessHandler();
      }
    };

    const imagebase64 = await imageToBase64(image);

    dispatch(
      updateMemberViolation({
        memberViolationId: violationData.memberViolationId,
        description,
        score: Number(score),
        image: imagebase64,
        successHandler,
      }),
    );
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Edit Violation</h1>
      </div>
      <form className={styles.formContainer}>
        <div className={styles.textAreaContainer}>
          <p className={styles.label}>Description</p>
          <textarea
            className={styles.textArea}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
          />
          <p className={styles.error}>{errors.description}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Score</p>
          <input
            type="text"
            className={styles.input}
            value={score}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                const num = Number(value);
                if (value === "" || num <= 30) {
                  setScore(value);
                }
              }
            }}
          />
          <p className={styles.error}>{errors.score}</p>
        </div>
        <div className={styles.imageInputContainer}>
          <p className={styles.label}>Image (Optional)</p>
          <input
            className={styles.imageInput}
            type="file"
            hidden
            ref={imageRef}
            accept="image/*"
            value={""}
            onChange={(e) => setImage(e.target.files?.[0] || null)}
          />
          {image ? (
            <div className={styles.inputImageContainer}>
              <img
                className={styles.inputImage}
                src={imageUrlHelper(image)}
                alt="Violation"
              />
              <div className={styles.iconContainer}>
                <IoClose
                  className={styles.icon}
                  onClick={() => setImage(null)}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.imageInputBox}
              onClick={() => imageRef.current?.click()}
            >
              <div className={styles.iconContainer}>
                <CiImageOn className={styles.icon} />
              </div>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Upload Image</p>
              </div>
            </div>
          )}
        </div>
        {updateMemberViolationLoading && <Loading />}
      </form>

      <div className={styles.buttonContainer}>
        <button className={styles.button} onClick={editViolationHandler}>
          Update
        </button>
        <button className={styles.cancelBtn} onClick={() => setIsOpen(false)}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default EditViolation;
